/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockIcon20Solid = forwardRef('TimeClockIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.48-12.182a.75.75 0 0 0-1.5 0v3.507a2 2 0 0 0 1.085 1.78l3.026 1.554a.75.75 0 1 0 .685-1.334L10.751 9.77a.5.5 0 0 1-.272-.445V5.818Z" })));
});
